import { ILayerProps, MaterialIdsType } from '@/version-types';
import { EliminateType } from '../types';

// 添加素材 id 标记
export const updateMaterialIds = (layer: ILayerProps, eliminateType?: EliminateType, commercialFun?: string) => {
    // 写入 AI 消除的使用标志，用于商业化权益核销的判断
    if (eliminateType !== EliminateType.AI) return;

    if (!layer.materialIds) {
        layer.materialIds = {};
    }

    const funcList = layer.materialIds[MaterialIdsType.FUNC_LIST] || [];

    if (commercialFun && !funcList.includes(commercialFun)) {
        funcList.push(commercialFun);
        layer.materialIds[MaterialIdsType.FUNC_LIST] = funcList;
    }
};

// 判断图层是否使用过 AI 消除
export const isAIEliminateUsed = (layer: ILayerProps, commercialFunc?: string) => {
    const funcList = layer.materialIds?.[MaterialIdsType.FUNC_LIST] || [];

    return commercialFunc ? funcList.includes(commercialFunc) : false;
};
